import {
    ApiBlueprint,
    discoveryApiRef,
    fetchApiRef,
    PageBlueprint
} from '@backstage/frontend-plugin-api'
import { agentApiRef, AgentApiClient } from '../api';
import { rootRouteRef } from '../routes';
import { ChatIcon } from '@backstage/core-components';

export const genai = PageBlueprint.make({
    name: 'genai',
    params: {
        path: '/aws-genai/:agentName',
        title: 'Chat Assistant',
        routeRef: rootRouteRef,
        noHeader: true,
        icon: <ChatIcon />,
        loader: async () =>
            import('../components/AgentPage').then((m) =>
                <m.AgentPage />
            ),
    },
});


export const awsGenAiApi = ApiBlueprint.make({
    name: 'aws-genai',
    params: (defineParams: any) =>
        defineParams({
            api: agentApiRef,
            deps: {
                discoveryApi: discoveryApiRef,
                fetchApi: fetchApiRef
            },
            factory: ({
                discoveryApi,
                fetchApi,
            }: any) =>
                new AgentApiClient({ discoveryApi, fetchApi }),
        }),
});